import React, { useId } from 'react'

interface BuyIconProps {
  className?: string
}

export const BuyIcon: React.FC<BuyIconProps> = ({ className }) => {
  const id = useId()
  const paint0Id = `paint0_linear_${id}`
  const paint1Id = `paint1_linear_${id}`

  return (
    <svg viewBox="0 0 24 25" fill="none" className={className}>
      <path
        d="M14.22 2.55L15.82 3.78C18.50 5.87 18.06 10.92 14.84 15.07C11.61 19.22 6.82 20.90 4.14 18.81L2.52 17.51M14.05 2.37C16.73 4.46 16.30 9.52 13.07 13.67C9.84 17.82 5.05 19.49 2.37 17.41C-0.32 15.32 0.12 10.26 3.34 6.11C6.57 1.96 11.36 0.29 14.05 2.37Z"
        stroke={`url(#${paint0Id})`}
      />
      <path
        d="M21.20 22.87L19.81 23.67C17.47 25.03 13.87 23.19 11.78 19.56C9.69 15.94 9.89 11.90 12.24 10.55L13.68 9.74M21.38 22.79C19.04 24.15 15.44 22.31 13.34 18.68C11.25 15.06 11.46 11.02 13.80 9.66C16.15 8.31 19.75 10.15 21.84 13.78C23.93 17.40 23.73 21.44 21.38 22.79Z"
        stroke={`url(#${paint1Id})`}
      />
      <defs>
        <linearGradient
          id={paint0Id}
          x1="5.98"
          y1="1.48"
          x2="9.59"
          y2="20.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" />
          <stop offset="0.65" stopColor="#C0C0C0" />
          <stop offset="0.76" stopColor="#C0C0C0" />
          <stop offset="1" stopColor="#4F4F4F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="22.22"
          y1="24.70"
          x2="10.77"
          y2="19.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" />
          <stop offset="0.42" stopColor="#C0C0C0" />
          <stop offset="1" stopColor="#4F4F4F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
